import React, { useEffect, useState } from "react";
import { getOrderDetail } from "../../../../services/LocationService";
import { PriceDetail } from "../../../../models/Order";
import User from "../../../../models/User";
import { getUserDetail } from "../../../../services/UserService";
import { getPartnerDetail } from "../../../../services/PartnerService";
import Partner from "../../../../models/Partner";

export default function usePartnerDetail(props: { id: string; openDialog?: boolean }) {
	const [userDetail, setUserDetail] = useState<Partner>();
	const loadPartner = async () => {
		try {
			var res = await getPartnerDetail(props.id);

			setUserDetail(res);
		} catch (err) {
			console.error(err);
		}
	};
	const reload = () => {
		loadPartner();
	};
	useEffect(() => {
		if (props.id && props.id != "0" && props.openDialog) {
			reload();
		}
	}, [props.id, props.openDialog]);
	return {
		userDetail,
		reloadDetail: reload,
	};
}
